import { get } from './';

export const getStyles = async ({
  locale,
  search,
  discarded,
  page,
  perPage,
  direction = 'desc',
  order = 'id',
}) => {
  const params = new URLSearchParams({
    ...(locale && { locale }),
    ...(search && { search }),
    ...(page && { page }),
    ...(perPage && { perPage }),
    ...(discarded && discarded !== 'undefined' && { discarded }),
    order,
    direction,
  });
  return get(`/styles?${params.toString()}`);
};
